import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/plugins/element-ui/components.js";
import "@/assets/styles/index.less";

Vue.config.productionTip = false;

import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: require("@/assets/images/loading.gif"),
  error: require("@/assets/images/error-img.svg"),
  attempt: 1,
  throttleWait: 800,
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
